import { createSelector } from '@reduxjs/toolkit';
import { EditorPlatform } from '@wix/ambassador-cc-helpcenter-v1-related-document/types';
import { HomepageContent, ResourcesSection, SectionId } from '@wix/wix-help-widget-common/homepage';

import { TRootState } from '../reducers';
import { IHomepageSectionState, ISearchConfig } from '../reducers/types';

type HomepageContentState = IHomepageSectionState<HomepageContent>;

export const selectSearchConfig = (state: TRootState): ISearchConfig => state.homepage.searchConfig;

export const selectHomepageContent = createSelector(
  (state: TRootState) => state.homepage.content,
  ({ data, loading, error }): HomepageContentState => ({
    data,
    loading,
    error,
  }),
);

export const selectReportABugFlowStarted = (state: TRootState): boolean => {
  return state.homepage.reportABugFlowStarted;
};

export const selectShowReportABugConfirmationModal = (state: TRootState): boolean => {
  return state.homepage.showReportABugConfirmationModal;
};

export const selectReportABugPosition = (state: TRootState): number => {
  return state.homepage.reportABugPosition;
};

export const selectReportABugText = (state: TRootState): string | undefined => {
  return state.homepage.reportABugText;
};

export const selectResourcesSection = createSelector(
  (state: TRootState) => state.homepage.content.data,
  (content): ResourcesSection | undefined => {
    const resourcesSection = content?.sections.find((section) => section.sectionId === SectionId.Resources);

    return resourcesSection as ResourcesSection;
  },
);

export const selectEditorType = createSelector(
  (state: TRootState) => state.homepage.searchConfig?.filters?.editorType,
  (editorType): EditorPlatform | undefined => editorType,
);
